import cn from 'classnames';
import throttle from 'lodash/throttle';
import React, { useEffect, useRef, useState } from 'react';

import styles from './sticky-element-wrapper.module.scss';

export const StickyElementWrapper: React.FC<{
  stickyClassName?: string;
  className: string | undefined;
  topDistance?: number;
  children: React.ReactNode;
}> = ({ stickyClassName, children, className, topDistance }) => {
  const [isElementSticky, setIsElementSticky] = useState(false);
  const wrapperRef = useRef<HTMLDivElement>(null!);

  const handleScroll = (elementTopDistance: number) => {
    if (elementTopDistance && stickyClassName) {
      if (window.scrollY > elementTopDistance) {
        setIsElementSticky(true);
        return;
      }

      setIsElementSticky(false);
    }
  };

  useEffect(() => {
    const offsetTop = wrapperRef.current.offsetTop;

    const elementTopDistance = topDistance || offsetTop;
    const scrollHandler = throttle(() => handleScroll(elementTopDistance), 150);

    window.addEventListener('scroll', scrollHandler);

    return () => {
      window.removeEventListener('scroll', scrollHandler);
    };
  }, []);

  return (
    <div
      ref={wrapperRef}
      className={cn(styles.stickyElement, className, {
        [stickyClassName as string]: isElementSticky,
      })}
    >
      {children}
    </div>
  );
};
